class ProductCard extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.SELECTORS = {
      swiperSlide: ".swiper-slide",
      mainImage: ".main-image",
      variantSwiper: ".variantSwiper",
      dataContainers: "[data-product-handle-switch]",
      imageLink: "[data-image-link]",
    };
    this.slides = this.querySelectorAll(this.SELECTORS.swiperSlide);
    this.swiper = this.querySelector(this.SELECTORS.variantSwiper);
    this.containers = this.querySelectorAll(this.SELECTORS.dataContainers);
    this.imageLink = this.querySelector(this.SELECTORS.imageLink);
    this.mainImages = [...this.querySelectorAll(".main-image")];
    this.slides.forEach((element, index) => {
      element.addEventListener("click", () => {
        this.changeVariant(element);
      });
    });
    this.mainImage = this.querySelector(this.SELECTORS.mainImage);
    this.initSwiper();
  }

  disconnectedCallback() {}
  changeVariant = (element) => {
    const productHandle = element.dataset.productHandle;
    this.mainImages.forEach((img) => {
      img.dataset.handle === productHandle
        ? img.classList.add("visible")
        : img.classList.remove("visible");
    });
    this.slides.forEach((sl) => sl.classList.remove("active-swatch"));
    element.classList.add("active-swatch");
    this.containers.forEach((el) => (el.hidden = true));
    const container = this.querySelector(
      "[data-product-handle-switch='" + productHandle + "']"
    );
    container.hidden = false;
    this.imageLink.setAttribute(
      "href",
      container.querySelector("a").getAttribute("href")
    );
  };

  initSwiper = () => {
    this.swiper = new Swiper(this.swiper, {
      slidesPerView: "auto",
      spaceBetween: 12,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      nested: this.dataset.nested ?? false,
      slideToClickedSlide: true,
    });
  };
}

if (!customElements.get("product-card")) {
  customElements.define("product-card", ProductCard);
}
